import React from 'react';
import Image from 'next/legacy/image';
import { Heading2, SmallHeading } from '@/components/Views/Heading';
import NormalText from '@/components/Views/Text';
import { LargeButton } from '@/components/Views/Buttons';
import { useDispatchUi } from '@/context/ui';
import MockLaptop from '@/components/MockLaptop/MockLaptop';

const HowItWorksNew = ({ videoLink = null, id }) => {
    const dispatch: any = useDispatchUi();

    return (
        <section id={id} className='w-full default-py default-px bg-white mt-10 '>
            <div className='default-max-w flex flex-col lg:flex-row gap-4 sm:gap-10 mx-auto my-0 items-center justify-center'>
                <div className='flex-grow' style={{ flexBasis: '50%' }}>
                    <Heading2 heading='AN AWARD-WINNING PLATFORM' className='md:text-center lg:text-left font-[800] text-[#28294E] text-[24px] md:text-[28px] lg:text-[28px] xl:text-[28px] 2xl:text-[28px] ' />
                    <NormalText className='font-normal text-[#28294E] leading-[1.65]  mt-8'>
                        Our team of #1 hit songwriters, GRAMMY-award winners,  PhDs and learning experts have created music videos and gamified quizzes that
                        help ALL kids ace math.
                    </NormalText>
                    <NormalText className='font-normal text-[#28294E] leading-[1.65]  mt-8'>
                        <span className='font-bold'>Muzology</span> is dedicated to continued improvement and innovation — in order to provide the highest
                        quality learning experience for your child, eradicate performance gaps in  education and help ALL learners reach their full potential.
                    </NormalText>
                </div>
                <div className='flex-grow basis-[100%] text-left'>
                    <MockLaptop />
                </div>
            </div>
        </section>
    );
};

export default HowItWorksNew;
